function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { string, arrayOf, number, bool } from 'prop-types';
import { Doughnut } from 'react-chartjs-2';
import { fontStyles, toolTipStyles, labelStyles } from './DoughnutChart.styles';

// This function calculates the percentage of a part of a whole
// represented in a doughnut chart
const getPercentageOfDoughnut = (partValue, total) => Math.round(partValue / total.reduce((partial_sum, a) => partial_sum + a, 0) * 100 * 10) / 10;
export const DoughnutChart = _ref => {
  let {
    label,
    labels,
    backgroundColor,
    data,
    hasTooltip,
    displayLegend
  } = _ref;
  return /*#__PURE__*/React.createElement(Doughnut, {
    data: {
      labels,
      datasets: [{
        label,
        data,
        backgroundColor,
        hoverOffset: 0
      }]
    },
    options: {
      borderWidth: 0,
      font: fontStyles,
      plugins: {
        tooltip: _objectSpread(_objectSpread({
          enabled: hasTooltip
        }, toolTipStyles), {}, {
          callbacks: {
            label: tooltipItems => {
              const {
                label: toolTipLabel,
                parsed,
                dataset
              } = tooltipItems;
              return "".concat(toolTipLabel, " ").concat(getPercentageOfDoughnut(parsed, dataset.data), "%");
            },
            labelColor: _ref2 => {
              let {
                dataIndex,
                dataset
              } = _ref2;
              return _objectSpread(_objectSpread({}, labelStyles), {}, {
                backgroundColor: dataset.backgroundColor[dataIndex]
              });
            }
          }
        }),
        legend: {
          display: displayLegend,
          position: 'bottom',
          fullSize: true,
          align: 'center',
          labels: {
            usePointStyle: true,
            boxWidth: 6
          }
        }
      }
    }
  });
};
DoughnutChart.propTypes = {
  label: string.isRequired,
  labels: arrayOf(string).isRequired,
  backgroundColor: arrayOf(string).isRequired,
  data: arrayOf(number).isRequired,
  displayLegend: bool,
  hasTooltip: bool
};
DoughnutChart.defaultProps = {
  displayLegend: false,
  hasTooltip: false
};